// The reasons a pending review cannot be completed, shared by the pending-reviews listing and the pending-review alert listing.

export const noPerformReviewAccessMessage = "You do not have permission to complete reviews.";

export const noReviewTopicAccessMessage = "You do not have permission to complete this review.";
